<!-- Deprecated, use FormTextInput instead -->
<template>
  <b-form-input
    :name="name"
    :required="required"
    :placeholder="placeholder"
    :value="value"
    no-outer-focus
    size="md"
    @input="input"
    v-on="listeners"
  />
</template>

<script>
export default {
  name: 'FormTextInput',
  props: {
    name: {
      type: String,
      requried: false,
      default: '',
    },
    required: {
      type: Boolean,
      requried: false,
      default: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Please write here',
    },
    value: {
      type: String,
      required: false,
      default: '',
    },
  },
  computed: {
    listeners () {
      const { input, ...listeners } = this.$listeners
      return listeners
    },
  },
  methods: {
    input (value) {
      this.$emit('input', value)
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
